import React from "react";
import HedgehogMascot from "@/components/HedgehogMascot";
export default function EmptyState({ title = "Rien à afficher", subtitle = "", action = null }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center gap-3">
      <HedgehogMascot size={110} />
      <div className="text-xl font-bold text-neutral-100">{title}</div>
      {subtitle && <div className="text-neutral-400 max-w-md">{subtitle}</div>}
      {action}
    </div>
  );
}
